function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

import React from 'react';
import t from 'prop-types';
import CajaMiniaturas from './../flashcards/caja-miniaturas';
import { Boton, BotonImagen } from './../botones';
import VentanaSimple from './../ventana-simple/index';

var VentanaImpresion = function (_React$Component) {
  _inherits(VentanaImpresion, _React$Component);

  function VentanaImpresion(props) {
    _classCallCheck(this, VentanaImpresion);

    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));

    _this.handleSeleccionar = function (index) {
      var fcsSeleccionados = [].concat(_this.state.fcsSeleccionados);
      fcsSeleccionados[index] = !fcsSeleccionados[index];

      _this.setState({
        fcsSeleccionados: fcsSeleccionados
      });
    };

    _this.handleTexto1 = function () {
      return _this.setState({
        texto: 1
      });
    };

    _this.handleTexto0 = function () {
      return _this.setState({
        texto: 0
      });
    };

    _this.handleCerrar = function () {
      return _this.props.onCerrar();
    };

    _this.handleImprimir = function () {
      var onImprimir = _this.props.onImprimir;
      var _this$state = _this.state,
          fcsSeleccionados = _this$state.fcsSeleccionados,
          texto = _this$state.texto;
      var fcs = [];
      fcsSeleccionados.forEach(function (seleccionado, index) {
        if (!seleccionado) {
          return;
        }

        fcs.push(_this.props.fcs[index]);
      });
      onImprimir(fcs, texto);
    };

    _this.getNumFcsSeleccionados = function () {
      var fcsSeleccionados = _this.state.fcsSeleccionados;
      return fcsSeleccionados.reduce(function (previousValue, currentValue) {
        return currentValue ? previousValue + 1 : previousValue;
      }, 0);
    };

    _this.state = {
      texto: 0,
      fcsSeleccionados: props.fcs.map(function () {
        return false;
      })
    };
    return _this;
  }

  VentanaImpresion.prototype.componentDidUpdate = function componentDidUpdate(prevProps) {
    var fcs = this.props.fcs;

    if (prevProps.fcs.length !== fcs.length) {
      this.setState({
        fcsSeleccionados: fcs.map(function () {
          return false;
        })
      });
    }
  };

  VentanaImpresion.prototype.render = function render() {
    var _props = this.props,
        abierta = _props.abierta,
        fcs = _props.fcs,
        textoImprimir = _props.textoImprimir,
        textoImagenes = _props.textoImagenes,
        textoImagenesMasPalabras = _props.textoImagenesMasPalabras;
    var _state = this.state,
        fcsSeleccionados = _state.fcsSeleccionados,
        texto = _state.texto;
    var numFcsSeleccionados = this.getNumFcsSeleccionados();
    return React.createElement(VentanaSimple, {
      clases: 'impresion',
      flotante: true,
      tieneAnimacion: false,
      escalable: true,
      abierta: abierta,
      ancho: '90%',
      alto: '80%'
    }, React.createElement('div', {
      className: 'botoneraVentana'
    }, React.createElement('div', {
      id: 'botonEnlace2',
      className: 'botonEnlace botonTitulo'
    }, React.createElement('span', null, textoImprimir)), React.createElement('div', {
      className: 'arrastreVentana'
    }), React.createElement(BotonImagen, {
      clases: 'cerrarVentana',
      onClick: this.handleCerrar
    })), React.createElement('div', {
      className: 'contenidosVentana'
    }, React.createElement(CajaMiniaturas, {
      flashcards: fcs,
      seleccionadas: fcsSeleccionados,
      onSeleccionar: this.handleSeleccionar
    })), React.createElement('div', {
      className: 'botoneraInferiorVentana'
    }, React.createElement('label', {
      htmlFor: 'imagen',
      className: 'opciones'
    }, React.createElement('input', {
      id: 'imagen',
      type: 'radio',
      name: 'opciones',
      value: 'imagen',
      onClick: this.handleTexto0,
      checked: texto === 0
    }), textoImagenes), React.createElement('label', {
      htmlFor: 'ambos',
      className: 'opciones'
    }, React.createElement('input', {
      id: 'ambos',
      type: 'radio',
      name: 'opciones',
      value: 'imagen+palabra',
      onClick: this.handleTexto1,
      checked: texto === 1
    }), textoImagenesMasPalabras), React.createElement(Boton, {
      clases: 'botonImprimir',
      desactivado: numFcsSeleccionados === 0,
      onClick: this.handleImprimir
    }, textoImprimir)));
  };

  return VentanaImpresion;
}(React.Component);

VentanaImpresion.propTypes = process.env.NODE_ENV !== "production" ? {
  abierta: t.bool.isRequired,
  fcs: t.array.isRequired,
  onCerrar: t.func.isRequired,
  onImprimir: t.func.isRequired,
  textoImprimir: t.string,
  textoImagenes: t.string,
  textoImagenesMasPalabras: t.string
} : {};
export default VentanaImpresion;